/**
 * This layout has navigation, header and footer.
 * This layout is used in protected or private "Routes"
 */

import React from "react";
/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import MUI component starts */
/* Import MUI component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import Header from "../../../components/layout/Header/Header";
import BreadCrumb from "../../../components/ui/other/BreadCrumb/BreadCrumb";
/* Import local pages and component ends */

import "./style.scss";
import { useSelector } from "react-redux";
import { getIsTENANT } from "../../store/slices/authSlice";
import TenantBreadCrumb from "../../../components/ui/other/TenantBreadCrumb/TenantBreadCrumb";

/* Component starts */
const Layout2 = (props) => {
  /* Props destructuring starts */
  /* Props destructuring ends */

  /* Component states declaration starts */
  /* Component states declaration ends */

  /* Other hooks declaration starts */
  const isTenant = useSelector(getIsTENANT);

  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="layout-2-wrapper">
      <Header />
      {isTenant && <TenantBreadCrumb />}
      <div className="body">{props.children}</div>
    </div>
  );
};
/* Component ends */

export default Layout2;
